
		var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;
var playerReady = false;
function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
            height: '390',
            width: '640',
            playerVars: {
                'controls': 1,
                'rel': 0
            },
            events: {
                'onReady': onPlayerReady
            }
        });
}
function onPlayerReady(event) {
	playerReady = true;
}
// document.addEventListener('DOMContentLoaded', function() {
// 	console.log("after page is loaded");
//     // 2. This code loads the IFrame Player API code asynchronously.
//     var tag = document.createElement('script');

//     tag.src = "https://www.youtube.com/iframe_api";
//     var firstScriptTag = document.getElementsByTagName('script')[0];
//     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

//     // 3. This function creates an <iframe> (and YouTube player)
//     //    after the API code downloads.
//     var player;

//     function onYouTubeIframeAPIReady() {
//         player = new YT.Player('player', {
//             height: '390',
//             width: '640',
//             playerVars: {
//                 'controls': 1,
//                 'rel': 0
//             },
//             events: {
//                 'onReady': onPlayerReady
//             }
//         });
//     }

//     var playerReady = false;
//     // 4. The API will call this function when the video player is ready.
//     function onPlayerReady(event) {
//         playerReady = true;
//     }

//     function stopVideo() {
//         if (playerReady = true) { // Check to see if Youtube API is ready
//            player.stopVideo();
//         }
//     }
//     function pauseVideo() {
//         if (playerReady = true) { // Check to see if Youtube API is ready
//             player.pauseVideo();
//         }
//     }
// });


/*================================
=            Lightbox            =
================================*/
function stopVideo() {
	if (playerReady = true) { // Check to see if Youtube API is ready
	   player.stopVideo();
	}
}
function pauseVideo() {
	if (playerReady = true) { // Check to see if Youtube API is ready
		player.pauseVideo();
	}
}

    var $lbox_position = "";
	var lbox__trigger = document.querySelectorAll('.lbox__item');
	var lbox__controls = document.querySelector('.lbox__controls');
	var lbox = document.querySelector('.lbox');
	var lbox__close = document.querySelector('.lbox__close');
	var body = document.querySelector('body');

	lbox__trigger.forEach(function(item) {

		item.addEventListener('click', function(e) {
			e.preventDefault();

			var lbox_type = item.getAttribute("data-lbox-type");

			var lbox_count = lbox__trigger[lbox__trigger.length - 1].getAttribute("data-lbox");
			if (lbox_count <= 1) {
				lbox__controls.style.display = 'none';
			}

			lbox_position = item.getAttribute("data-lbox");
			console.log("lbox_position" + lbox_position);
			// lbox.getAttribute('data-lbox-slide', lbox_position);

			// If Image
			if (lbox_type == 'image') {
				update_lbox(lbox_position);
			// If Video
			} else if (lbox_type == 'video') {
				if (playerReady == true) { // Check to see if Youtube API is ready

					update_lbox(lbox_position);
				} else {
				console.log("Youtube NOT READY!");
				}
			} else {
				console.log("No lbox type found");
			}

		});
	});

	if(lbox) {
		// Close video lightbox
		lbox.addEventListener('click', function(e) {
			e.preventDefault();
			close_lightbox();
		});

		// On close button close lightbox
		lbox__close.addEventListener('click', function(e) {
			e.preventDefault();
			close_lightbox();
		});
	}

    // Close video lightbox
    function close_lightbox() {
		lbox.style.display = "none";
        body.classList.remove("lbox-no-scroll");
        if(player) {
            stopVideo();
        }
    }

/*=========================================
=            Lightbox Controls            =
=========================================*/
    let current_lbox_num = "";
	const lbox__prev = document.querySelector('.lbox__prev');
	const lbox__next = document.querySelector('.lbox__next');
	let lbox__item = document.querySelectorAll('.lbox__item');

	if(lbox__prev){
		// Previous
		lbox__prev.addEventListener('click', function(e) {
			e.stopPropagation();
			prev_slide();
		});
	}


    function prev_slide() {
		var current_lbox_num = lbox.getAttribute('data-lbox-slide');

        if ((current_lbox_num - 1) > 0 ) {
            current_lbox_num--;
			update_lbox(current_lbox_num);

        } else {
            current_lbox_num = lbox__item[lbox__item.length - 1].getAttribute("data-lbox");
            current_lbox_num = lbox__item[lbox__item.length - 1].getAttribute("data-lbox");
			update_lbox(current_lbox_num);
        }
    }

	if(lbox__next){
		// Next
		lbox__next.addEventListener('click', function(e) {
			e.stopPropagation();
			next_slide();
		});
	}


    function next_slide() {
		console.log("next slide");

        let cur_lbox_num = lbox.getAttribute("data-lbox-slide");
        cur_lbox_num++;
        let lbox_last = lbox__item[lbox__item.length - 1].getAttribute("data-lbox");

        if (cur_lbox_num > lbox_last) {
            cur_lbox_num = 1;
        }
        update_lbox(cur_lbox_num);
    }

    // Keyboard controls
	document.addEventListener('keydown', function(e) {
        switch(e.which) {
            // case 37: // left
            //     if(lbox.classList.contains('display') != 'none') {
            //         prev_slide();
            //     }

            // break;

            // case 39: // right
            //     if(lbox.classList.contains('display') != 'none') {
            //         next_slide();
            //     }
            // break;

            case 27: // escape
                if(lbox.classList.contains('display') != 'none') {
                    close_lightbox();
                }
            break;

            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
	});

/*=====  End of Lightbox Controls  ======*/


    // Update lbox media
    function update_lbox(lbox_position) {
		let lbox_videocont = document.querySelector('.lbox__videocontainer');
		let lbox_imgcont = document.querySelector('.lbox__imagecontainer');
		let lbox_current_item = document.querySelector('.lbox__item[data-lbox="' + lbox_position + '"]');

		let lbox_type = lbox_current_item.getAttribute('data-lbox-type');

		lbox.setAttribute('data-lbox-slide', lbox_position);

		var item = document.querySelector('.lbox__item[data-lbox="' + lbox_position + '"]');

		// Get Href link
		let href = '';
		if (lbox_position) {
			href = item.querySelector('a').getAttribute('href');
		}

		// Get Caption from alt tag
		let caption = item.querySelector('img').alt;

		// var caption = item.querySelectorAll('p[data-lbox-caption]');

		lbox.style.display = 'flex';
		body.classList.add('lbox-no-scroll');
		lbox_videocont.style.display = 'none';
		lbox_imgcont.style.display = 'none';
		lbox__close.style.display = 'none';


        if (lbox_type == "video") {
            // Get youtube video id
            function youtube_parser(url){
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
                var match = url.match(regExp);
                return (match&&match[7].length==11)? match[7] : false;
            }

            var hrefs = youtube_parser(href);


            // $(".lbox__close").show();
			lbox__close.style.display = 'block';
            if (playerReady == true) { // Check to see if Youtube API is ready
                player.loadVideoById(hrefs, 0, "default");
            } else {
				console.log("Youtube player isn't ready");
			}
			lbox_videocont.style.display = 'block';

        } else if (lbox_type == "image") {
            if(player) {
                pauseVideo();
            }
			// lbox__close.style.display = 'none';
			lbox_imgcont.innerHTML = '<span><img src="' + href + '" alt="player" /></span><div><p>' + caption + '</p></div>';
			lbox_imgcont.style.display = 'block';

        } else {
			console.log("type not found");
		}

    }

  /**************************
   * Movie controls
   *************************/

  function videoplay() {
    if($("#player").length) { // If #player exists
      // setup variables
      var moviecontainer = document.getElementById("player"),
      movie = moviecontainer.querySelector("video"),
      controls = moviecontainer.querySelector("span");
      movie.removeAttribute("controls");
      controls.style.display = "block";

      // Play video
      $("#play-pause").on({
        mouseenter: function() {
          $('#play-pause span').toggle();
          movie.play();
        },
        mouseleave: function() {
          $('#play-pause span').toggle();
          movie.pause();
        }
      });

      $("#play-pause").on({
        click: function() {
          if(movie.paused) {
            $('#play-pause span').hide();
            movie.play();
          } else {
            $('#play-pause span').show();
            movie.pause();
          }
        }
      });
    } // END if $("#player")
  } // end function videoplay()
/*=====  End of Lightbox  ======*/